export const TAX_TYPE = [
  { 'id': 0, 'name': 'monthly', 'display': 'monthly', 'description': '' },
  { 'id': 2, 'name': 'yearly', 'display': 'yearly', 'description': '' },
];
export const TAX_TYPE_BY_NAME = TAX_TYPE.reduce((acc, payer) => {
  acc[payer['name']] = payer;
  return acc;
}, {});
